<script context="module" lang="ts">
  declare global {
    interface Window {
      userChannel: string | null
    }
  }
</script>

<script lang="ts">
  import config from 'config'
  import { setContext } from 'svelte'
  import { onMount } from 'svelte'
  import { Router, Route } from 'svelte-routing'
  import Loadable from 'svelte-loadable'
  import Client from './api'
  import Subscriber from './api/subscriber'
  import { currentUser, unreadMessages, unreadNotifications, features } from './stores/session'
  import Breadcrumb from './components/Breadcrumbs/Breadcrumb.svelte'

  // Props
  export let url = ''

  setContext('breadcrumbs', [])
  onMount(() => {
    // Get logged in user info
    const client = new Client()
    client
      .getCurrentSession()
      .then(user => {
        if (user) {
          const {
            id,
            thumbnail,
            thumbnail_url,
            thumbnail_background,
            full_name,
            channel_id,
            is_content_admin,
            is_gateway_admin,
            is_support_admin,
            can_create_definition,
            num_bookmarks,
            num_groups_member_of,
            num_galleries,
            num_maps,
            num_datasets,
            num_definitions,
            num_documents,
          } = user

          currentUser.set({
            id,
            hasPhoto: !!thumbnail,
            thumbnail: thumbnail_url,
            thumbnailBackground: thumbnail_background,
            fullName: full_name,
            channelId: channel_id,
            isContentAdmin: is_content_admin,
            isGatewayAdmin: is_gateway_admin,
            isSupportAdmin: is_support_admin,
            canCreateDefinition: can_create_definition,
            bookmarkCount: num_bookmarks,
            groupMembershipCount: num_groups_member_of,
            galleryCount: num_galleries,
            mapCount: num_maps,
            datasetCount: num_datasets,
            definitionCount: num_definitions,
            documentCount: num_documents,
          })

          // If logged in, get message counts
          void client.getMessageCounts().then(counts => unreadMessages.update(() => counts.unread_message_count))
        } else {
          currentUser.update(() => null)
        }
      })
      .catch(() => currentUser.update(() => null))

    void client
      .getNotificationCounts()
      .then(counts => unreadNotifications.update(() => counts.unread_notification_count))
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {})

    void client
      .getFeatures()
      .then(fts => features.set(fts))
      .catch(() => features.set(null))

    if (window.userChannel) {
      const userSubscriber = new Subscriber(window.userChannel)
      userSubscriber.addEventListener('message_counts', (event: CustomEvent) =>
        unreadMessages.update(() => event.detail.unread_message_count),
      )
      userSubscriber.addEventListener('notification_counts', (event: CustomEvent) =>
        unreadNotifications.update(() => event.detail.unread_notification_count),
      )
    }
  })
</script>

<Router {url}>
  <Breadcrumb label={window.gettext('Data Basin')} path="/">
    <Route path="/">
      <Loadable loader={config.pages.home} />
    </Route>
    <Breadcrumb label={window.gettext('Admin Home')} path="admin/">
      <Breadcrumb label={window.gettext('Servers')} path="servers/">
        <Route path="/admin/servers/">
          <Loadable loader={config.pages.servers} />
        </Route>
      </Breadcrumb>
    </Breadcrumb>
  </Breadcrumb>
</Router>
